import { formatTextForDisplay } from '@src/shared/utils/helpers/format-text-for-display';
import { TASK_PRIORITY } from '@src/shared/types/task';
import { createSimpleFilterConfig } from '../factories/create-simple-filter-config';
import { FILTER_COLOR } from './filter-colors';

export const taskPriorityFilterConfig = createSimpleFilterConfig({
  facetName: 'priority',
  options: Object.values(TASK_PRIORITY).map((priority) => ({
    label: formatTextForDisplay(priority),
    value: priority,
  })),
  color: FILTER_COLOR.green,
});
